import classes from "./Tag.module.css";
export default function Tag({ title, id, onClickHandler, mergeMode }) {
  return (
    <>
      <div
        className={`${classes.tagContainer} ${mergeMode && classes.shake}`}
        onClick={(e) => {
          onClickHandler(e);
        }}
      >
        <label htmlFor="" hidden>
          {id}
        </label>
        {title}
      </div>
    </>
  );
}
